import { Alert, Snackbar } from "@mui/material";
import { Button } from "components/button";
import { WrapSectionLayout } from "components/common";
import { DropdownSearch } from "components/dropdownSearch";
import { IconFile } from "components/icons";
import { InputDatePicker } from "components/input";
import Input from "components/input/Input";
import { Kanban } from "components/kanban";
import { PopupInfomation } from "components/popupInfomation";
import { WrapTableEdit } from "components/tableEdit";
import { FakeData } from "constants/FakeData";
import { useMountTransition } from "hooks/useMountTransition";
import { TitleDashboard } from "modules/titleDashboard";
import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { ItemKanbanLead, ItemKanbanLeadDetail } from ".";
const LeadKanban = () => {
	const showDetail = useSelector(state => state.kanban.showDetail);
	const hasTransitionedIn = useMountTransition(showDetail, 1000);
	const {
		control,
		handleSubmit,
		formState: { errors, isValid, isSubmitting },
	} = useForm({
		mode: "onChange",
	});
	return (
		<WrapSectionLayout className='section-list-lead-kanban'>
			<div className='board-white'>
				<TitleDashboard
					urlAdd='Create'
					typeAdd
					typeExport
					isToggleKanban
					linkKanban='/Lead/Kanban'
					linkTable='/Lead'>
					Danh sách Lead
				</TitleDashboard>
				<form className='wrap-form flex mt-3 gap-x-30px items-end flex-col gap-y-20px lg:gap-y-0px lg:flex-row flex-wrap'>
					<div className='grid grid-cols-2 gap-y-24px lg:gap-y-0 gap-x-20px w-full lg:flex lg:flex-1 xl:gap-x-40px'>
						<Input
							label='Tìm kiếm'
							control={control}
							name='SearchName'
							className='relative !w-full lg:!w-180px xl:!w-300px flex-shrink-0'></Input>
						<DropdownSearch
							label='Trạng thái'
							name='Status'
							data={FakeData.Level}
							control={control}></DropdownSearch>
						<DropdownSearch
							label='Account'
							name='Account'
							data={FakeData.Level}
							control={control}></DropdownSearch>
						<InputDatePicker
							label='Ngày bắt đầu'
							control={control}
							name='SearchStartDate'></InputDatePicker>
						<InputDatePicker
							label='Ngày kết thúc'
							control={control}
							name='SearchEndDate'></InputDatePicker>
					</div>
					<Button kind='filter'></Button>
				</form>
				<div className='wrap-box-kanban mt-30px'>
					<Kanban data={FakeData.listDataKanbanLead}>
						<ItemKanbanLead></ItemKanbanLead>
					</Kanban>
					{(hasTransitionedIn || showDetail) && (
						<ItemKanbanLeadDetail
							className={`${hasTransitionedIn && "in"} ${
								showDetail && "show"
							}`}></ItemKanbanLeadDetail>
					)}
				</div>
			</div>
		</WrapSectionLayout>
	);
};

export default LeadKanban;
